import React from 'react'
import { HubCompanyCityHallMain } from 'domain/feature/hub/company/city-hall-main'

export const HubCompanyCityHallMainPage = (): JSX.Element => {
  return (
    <HubCompanyCityHallMain />
  )
}
